type Props = {
  limit: number | undefined;
  remaining: number | undefined;
  unit: string;
};

export function ToolLimitTextLong({ limit, remaining, unit }: Props) {
  return (
    <>
      {limit === -1 ? (
        <>Unlimited {unit} generation — available for a short time only</>
      ) : (
        <>
          You have{" "}
          {remaining === undefined ? (
            <span className="loading loading-spinner w-3"></span>
          ) : (
            remaining
          )}{" "}
          {unit}(s) left today
        </>
      )}
    </>
  );
}

export function ToolLimitTextShort({ limit, remaining, unit }: Props) {
  return (
    <>
      {limit === -1 ? (
        <>(Temporarily unlimited)</>
      ) : (
        <>
          (
          {remaining === undefined ? (
            <span className="loading loading-spinner w-3"></span>
          ) : (
            remaining
          )}{" "}
          {unit}(s) left today)
        </>
      )}
    </>
  );
}
